var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbCreditcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.54 24.33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_creditcard_svg__cls-1",
    d: "M31.13.5H3.42A2.92 2.92 0 00.5 3.42v17.5a2.91 2.91 0 002.92 2.91h27.71A2.91 2.91 0 0034 20.92V3.42A2.91 2.91 0 0031.13.5zM.5 6.33H34",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbCreditcard;